import { render, staticRenderFns } from "./LimitedPartners.vue?vue&type=template&id=3d831844&scoped=true"
import script from "./LimitedPartners.vue?vue&type=script&lang=js"
export * from "./LimitedPartners.vue?vue&type=script&lang=js"
import style0 from "./LimitedPartners.vue?vue&type=style&index=0&id=3d831844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d831844",
  null
  
)

export default component.exports